const eventSubsEmail = (params) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `footer_subscribe_button`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on subscribe`,
    eventLabel: `subscribe`,
    email: `${params.toLowerCase()}`,
  });
};
export default eventSubsEmail;
